<template>
  <div>

    <NavigationBar
        :user="user"
        :is-logged-in="isLoggedIn"
    />
    <NavStepper :menu="menu" />
    <main>
      <slot />
    </main>
    <FooterSection />
    <PwaInstallPrompt />
    <WhatsAppFloat phone-number="237694081678" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import {useAuthStore} from "~/stores/auth/index.js";
import {Capacitor} from "@capacitor/core";
import WhatsAppFloat from "~/components/landing/WhatsAppFloat.vue";


const authStore = useAuthStore()
// Simulation de l'état utilisateur (à remplacer par votre logique d'authentification)
const user = ref({
  name: `${authStore.userName}`,
  email: `${authStore.userEmail}`,
  avatar: authStore.user?.profile?.avatar_url || 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
})

const isLoggedIn = ref(authStore.isLoggedIn)
// Créer un computed pour rendre la propriété réactive
const isAuthenticated = computed(() => authStore.isAuthenticated)
watch(isAuthenticated, (newValue) => {
    user.value = {
      name: `${authStore.userName}`,
      email: `${authStore.userEmail}`,
      avatar: authStore?.user?.profile?.avatar_url || 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
    }
  isLoggedIn.value = newValue

})

const menu = [
  // { href: '#hero', label: 'hero' },
  { href: '#services', label: 'nav.services' },
  { href: '#realisation', label: 'nav.realisation' },
  { href: '#about', label: 'nav.about' },
  { href: '#testimonial', label: 'nav.testimonial' },
  { href: '#client', label: 'nav.customer' },
  { href: '#faq', label: 'nav.faq' },
]

</script>

<style scoped>

</style>